import { render, staticRenderFns } from "./PromoCodeListEditForm.vue?vue&type=template&id=ec8e9674&scoped=true&"
import script from "./PromoCodeListEditForm.vue?vue&type=script&lang=js&"
export * from "./PromoCodeListEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec8e9674",
  null
  
)

export default component.exports